module.exports = __webpack_public_path__ + "media/images/icons/v2/settings-04-3e47c5c2001e961751363b21114660cd.svg";